
const SCALE = 96 / 72;


export {SCALE}